<template>
  <div class="graph-container">
    <canvas
      id="graph"
      ref="graph" />
  </div>
</template>

<script>
import Chart from 'chart.js'
import Utils from '../../helpers/utilities'
import { mapGetters } from 'vuex'

export default {
  props: {
    labels: {
      type: Array,
      require: true,
      default: Array
    },
    values: {
      type: Array,
      require: true,
      default: Array
    },
    users: {
      type: Array,
      require: true,
      default: Array
    },
    user_type:{
        type: String,
        require: true,
        default: String
    },
    loan_request_invoices: {
      type: Array,
      require: true,
      default: Array
    },
    loan_approved_invoices: {
      type: Array,
      require: true,
      default: Array
    },
    loan_verified_invoices: {
      type: Array,
      require: true,
      default: Array
    },
    loan_pending_invoices: {
      type: Array,
      require: true,
      default: Array
    },
    loan_offered_invoices: {
      type: Array,
      require: true,
      default: Array
    },
    loan_financed_invoices: {
      type: Array,
      require: true,
      default: Array
    },
    loan_rejected_invoices: {
      type: Array,
      require: true,
      default: Array
    },
    loan_prepaid_invoices: {
      type: Array,
      require: true,
      default: Array
    },
    loan_settlement_invoices: {
      type: Array,
      require: true,
      default: Array
    },
    paid_invoices: {
      type: Array,
      require: true,
      default: Array
    },
    sent_po: {
      type: Array,
      require: true,
      default: Array
    },
    accepted_po: {
      type: Array,
      require: true,
      default: Array
    },
    rejected_po: {
      type: Array,
      require: true,
      default: Array
    },
    settled_po: {
      type: Array,
      require: true,
      default: Array
    },
  },

  computed: {
    ...mapGetters('currency', [
      'defaultCurrency'
    ])
  },

  watch: {
    labels (val) {
      this.update()
    }
  },

  mounted () {
    let self = this
    let context = this.$refs.graph.getContext('2d')
    let options = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                
                }
            }]
        },    
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: false
        }
    }
    let data = {
      labels: this.labels,
      datasets: [
        {
          label: this.user_type,
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(230, 254, 249)',
          borderColor: '#040405',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#040405',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: '#040405',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.users
        },
        {
          label: 'Prepayment Request Invoices',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(230, 254, 249)',
          borderColor: 'rgba(97, 106,107, 1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(97, 106,107, 1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(97, 106,107, 1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.loan_request_invoices
        },
        {
          label: 'Approved Invoices',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(230, 254, 249)',
          borderColor: 'rgba(99, 57, 116, 1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(99, 57, 116, 1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(99, 57, 116, 1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.loan_approved_invoices
        },
        {
          label: 'Verified Invoices',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(236, 235, 249)',
          borderColor: 'rgba(88, 81, 216, 1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(88, 81, 216, 1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(88, 81, 216, 1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.loan_verified_invoices
        },
        {
          label: 'Pending Invoices',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(236, 235, 249)',
          borderColor: 'rgba(154, 44, 44,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(154, 44, 44,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(154, 44, 44,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.loan_pending_invoices
        },
        {
          label: 'Offered Invoices',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(236, 235, 249)',
          borderColor: 'rgba(40, 116, 116,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(40, 116, 116,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(40, 116, 116,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.loan_offered_invoices
        },
        {
          label: 'Financed Approved Invoices',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(236, 235, 249)',
          borderColor: 'rgba(173, 30, 87,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(173, 30, 87,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(173, 30, 87,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.loan_financed_invoices
        },
        {
          label: 'Rejected Invoices',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(245, 235, 242)',
          borderColor: 'rgb(255,0,0)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgb(255,0,0)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgb(255,0,0)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.loan_rejected_invoices
        },
        {
          label: 'Prepaid Invoices',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(245, 235, 242)',
          borderColor: 'rgba(158,157,36,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(158,157,36,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(158,157,36,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.loan_prepaid_invoices
        },
        {
          label: 'Settled Invoices',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(245, 235, 242)',
          borderColor: 'rgba(17,120,100,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(17,120,100,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(17,120,100,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.loan_settled_invoices
        },
        {
          label: 'Paid Invoices',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(245, 235, 242)',
          borderColor: 'rgba(53,73,48,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(53,73,48,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(53,73,48,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.paid_invoices
        },
        {
          label: 'Sent Purchase Order',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(245, 235, 242)',
          borderColor: 'rgba(169,110,26,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(169,110,26,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(169,110,26,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.sent_po
        },
         {
          label: 'Accepted Purchase Order',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(245, 235, 242)',
          borderColor: 'rgba(54,235,9,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(54,235,9,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(54,235,9,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.accepted_po
        },
         {
          label: 'Rejected Purchase Order',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(245, 235, 242)',
          borderColor: 'rgb(204,0,0)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgb(204,0,0)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgb(204,0,0)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.rejected_po
        },
        {
          label: 'Settled Purchase Order',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(245, 235, 242)',
          borderColor: 'rgba(255,77,77,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(255,77,77,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(255,77,77,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 4,
          pointHitRadius: 10,
          data: this.settled_po
        }

      ]
    }

    this.myLineChart = new Chart(context, {
        
      type: 'line',
      data: data,
      
      options: options
    })
  },
  methods: {
    update () {
        this.myLineChart.data.datasets[0].label = this.user_type
        this.myLineChart.data.labels = this.labels
        this.myLineChart.data.datasets[0].data = this.users
        this.myLineChart.data.datasets[1].data = this.loan_request_invoices
        this.myLineChart.data.datasets[2].data = this.loan_approved_invoices
        this.myLineChart.data.datasets[3].data = this.loan_verified_invoices
        this.myLineChart.data.datasets[4].data = this.loan_pending_invoices
        this.myLineChart.data.datasets[5].data = this.loan_offered_invoices
        this.myLineChart.data.datasets[6].data = this.loan_financed_invoices
        this.myLineChart.data.datasets[7].data = this.loan_rejected_invoices
        this.myLineChart.data.datasets[8].data = this.loan_prepaid_invoices
        this.myLineChart.data.datasets[9].data = this.loan_settleded_invoices
        this.myLineChart.data.datasets[10].data = this.paid_invoices
        this.myLineChart.data.datasets[11].data = this.sent_po
        this.myLineChart.data.datasets[12].data = this.accepted_po
        this.myLineChart.data.datasets[13].data = this.rejected_po
        this.myLineChart.data.datasets[14].data = this.settled_po
        
        this.myLineChart.update({
            lazy: true
        })
    },

    beforeDestroy () {
      this.myLineChart.destroy()
    }
  }
}
</script>

<style scoped>
.graph-container {
  height: 500px;
}
</style>
